<template>
  <el-dialog title="填写原因" :visible.sync="modalShow" append-to-body>
    <el-form size="small" ref="filter" :model="filter" :rules="rules" label-width="100px">
      <el-form-item label="添加原因" prop="reason">
        <el-input v-model="filter.reason" placeholder="请输入添加原因" clearable @blur="filter.reason = $event.target.value.trim()" />
      </el-form-item>
      <el-form-item label="备注" prop="remarks">
        <el-input type="textarea" :rows="4" :autosize="{maxRows:5,minRows: 5}" v-model="filter.remarks" placeholder="请输入备注" clearable @blur="filter.remarks = $event.target.value.trim()" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="modalShow = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
const rules = {
  reason: [
    {
      required: true,
      trigger: 'change',
      validator: (rule, value, callback) => {
        if (value) {
          callback()
        } else {
          callback(new Error('请选择原因'))
        }
      }
    }
  ]
}
export default {
  data () {
    return {
      rules,
      modalShow: false,
      filter: {
        reason: null,
        remarks: null
      }
    }
  },
  watch: {
    modalShow(v) {
      if (!v) {
        this.filter = {
          reason: null,
          remarks: null
        }
      }
    }
  },
  methods: {
    init () {
      this.modalShow = true
    },
    async submit () {
      this.$refs['filter'].validate(valid => {
        if (!valid) {
          this.$message.warning('请填写必填项！')
          return
        };
        this.modalShow = false
        // this.$message.success('操作成功')
        this.$emit('submit', true,this.filter)
      })
    }
  }
}
</script>

<style>
</style>
